enum SignalRConnectionState {
  Connecting = "Connecting",
  Connected = "Connected",
  Reconnecting = "Reconnecting",
  Reconnected = "Reconnected",
  Disconnected = "Disconnected",
}

export default SignalRConnectionState;